var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return typeof _vm.delegationDecision.calculations !== "undefined"
    ? _c(
        "div",
        [
          _c("div", { staticClass: "mb-2" }, [
            _c("h2", [_vm._v(_vm._s(_vm.$t("delegation.decision.summary")))])
          ]),
          _c(
            "div",
            [
              _c("strong", [
                _vm._v(_vm._s(_vm.$t("delegation.decision.status")) + ":")
              ]),
              _c("delegation-status-chip", {
                attrs: { status: _vm.delegationDecision.status }
              })
            ],
            1
          ),
          _vm.$store.state.Auth.userProperties == null ||
          _vm.$store.state.Auth.userProperties.system_settings
            .cost_centre_on_delegations !== 3
            ? _c("div", [
                _c("strong", [
                  _vm._v(
                    _vm._s(_vm.$t("delegationOrder.decision.costCentre")) + ": "
                  )
                ]),
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.delegationDecision.cost_centre == null
                        ? _vm.$t("global.notSet")
                        : _vm.delegationDecision.cost_centre.name
                    ) +
                    " "
                )
              ])
            : _vm._e(),
          _c("div", [
            _c("strong", [
              _vm._v(_vm._s(_vm.$t("delegation.decision.delegated")) + ": ")
            ]),
            _vm._v(
              _vm._s(_vm.delegationDecision.user_name) +
                " (" +
                _vm._s(_vm.delegationDecision.user_login) +
                ") "
            )
          ]),
          _c("div", [
            _c("strong", [
              _vm._v(_vm._s(_vm.$t("delegation.decision.destination")) + ":")
            ]),
            _vm._v(" " + _vm._s(_vm.delegationDecision.destinationText) + " ")
          ]),
          _vm.delegationDecision.task_name !== null &&
          _vm.delegationDecision.task_name !== ""
            ? _c("div", [
                _c("strong", [
                  _vm._v(_vm._s(_vm.$t("delegation.decision.task")) + ":")
                ]),
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$i18n.locale === "pl" ||
                        _vm.delegationDecision.task_name_en == null
                        ? _vm.delegationDecision.task_name
                        : _vm.delegationDecision.task_name_en
                    ) +
                    " "
                )
              ])
            : _vm._e(),
          _vm.delegationDecision.task != null &&
          _vm.delegationDecision.task.length > 0
            ? _c("div", [
                _c("strong", [
                  _vm._v(
                    _vm._s(_vm.$t("delegation.decision.taskDescription")) + ":"
                  )
                ]),
                _vm._v(" " + _vm._s(_vm.delegationDecision.task) + " ")
              ])
            : _vm._e(),
          _vm.delegationDecision.external_customer_name != null &&
          _vm.delegationDecision.external_customer_name.length > 0
            ? _c("div", [
                _c("strong", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("delegation.form.fields.externalCustomer.name")
                    ) + ":"
                  )
                ]),
                _vm._v(
                  " " +
                    _vm._s(_vm.delegationDecision.external_customer_name) +
                    " "
                )
              ])
            : _vm._e(),
          _vm.delegationDecision.project_name != null &&
          _vm.delegationDecision.project_name.length > 0
            ? _c("div", [
                _c("strong", [
                  _vm._v(
                    _vm._s(_vm.$t("delegation.form.fields.project.name")) + ":"
                  )
                ]),
                _vm._v(" " + _vm._s(_vm.delegationDecision.project_name) + " ")
              ])
            : _vm._e(),
          _c("div", [
            _c("strong", [
              _vm._v(_vm._s(_vm.$t("delegation.decision.startDate")) + ":")
            ]),
            _vm._v(" " + _vm._s(_vm.delegationDecision.start_date) + " ")
          ]),
          _c("div", [
            _c("strong", [
              _vm._v(_vm._s(_vm.$t("delegation.decision.endDate")) + ":")
            ]),
            _vm._v(" " + _vm._s(_vm.delegationDecision.end_date) + " ")
          ]),
          _c("div", { staticClass: "my-2" }, [
            _c("h2", [_vm._v(_vm._s(_vm.$t("delegation.decision.costs")))])
          ]),
          _vm.delegationDecision.calculations.isValidTransportType === 0
            ? _c("div", [
                _c("span", [
                  _c("b", { staticClass: "red--text" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "delegation.decision.transportOtherThanDelegationOrder"
                        )
                      ) + " "
                    )
                  ])
                ])
              ])
            : _vm._e(),
          _c("div", [
            _vm._v(
              " " + _vm._s(_vm.$t("delegation.decision.transportCost")) + ": "
            ),
            _c("span", [
              _c(
                "b",
                {
                  class: {
                    "green--text":
                      _vm.delegationDecision.calculations.isValidTransportLimit,
                    "red--text": !_vm.delegationDecision.calculations
                      .isValidTransportLimit
                  }
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.delegationDecision.calculations.transportCost.toFixed(
                        2
                      )
                    )
                  )
                ]
              )
            ]),
            !_vm.delegationDecision.calculations.isValidTransportLimit
              ? _c("span", { staticClass: "red--text" }, [
                  _c("b", [
                    _vm._v(
                      " (" +
                        _vm._s(_vm.$t("global.error.transportLimitExceeded")) +
                        ")"
                    )
                  ])
                ])
              : _vm._e()
          ]),
          _c("div", [
            _vm._v(
              " " +
                _vm._s(_vm.$t("delegation.decision.accommodationCost")) +
                ": "
            ),
            _c("span", [
              _c(
                "b",
                {
                  class: {
                    "green--text": !_vm.accommodationCostExceeded,
                    "red--text": _vm.accommodationCostExceeded
                  }
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.delegationDecision.calculations.accommodationCost.toFixed(
                        2
                      )
                    )
                  )
                ]
              )
            ]),
            _vm.accommodationCostExceeded
              ? _c("span", { staticClass: "red--text" }, [
                  _c("b", [
                    _vm._v(
                      " (" +
                        _vm._s(_vm.$t("global.error.hotelLimitExceeded")) +
                        ")"
                    )
                  ])
                ])
              : _vm._e()
          ]),
          _c("div", [
            _vm._v(" " + _vm._s(_vm.$t("delegation.decision.dietCost")) + ": "),
            _c("span", [
              _c("b", { staticClass: "green--text" }, [
                _vm._v(
                  _vm._s(
                    _vm.delegationDecision.calculations.countryCost.toFixed(2)
                  )
                )
              ])
            ])
          ]),
          _c("div", [
            _vm._v(
              " " + _vm._s(_vm.$t("delegation.decision.otherCost")) + ": "
            ),
            _c("span", [
              _c("b", { staticClass: "green--text" }, [
                _vm._v(
                  _vm._s(
                    _vm.delegationDecision.calculations.otherCost.toFixed(2)
                  )
                )
              ])
            ])
          ]),
          _c("div", [
            _vm._v(" " + _vm._s(_vm.$t("delegation.decision.advance")) + ": "),
            _c("span", [
              _c("b", { staticClass: "green--text" }, [
                _vm._v(
                  _vm._s(
                    _vm.delegationDecision.calculations.payedAdvances.toFixed(2)
                  )
                )
              ])
            ])
          ]),
          _c("div", [
            _c("strong", [
              _vm._v(
                _vm._s(_vm.$t("delegation.decision.returnToDelegated")) + ": "
              )
            ]),
            _c("span", [
              _c("b", { staticClass: "green--text" }, [
                _vm._v(
                  _vm._s(
                    _vm.delegationDecision.calculations.returnToWorkerCost.toFixed(
                      2
                    )
                  )
                )
              ])
            ])
          ]),
          _c(
            "v-btn",
            {
              staticClass: "primary mx-2",
              attrs: { disabled: _vm.$store.getters["Ajax/loading"] },
              on: { click: _vm.downloadSettlement }
            },
            [_vm._v(_vm._s(_vm.$t("delegation.decision.downloadSettlement")))]
          ),
          _c(
            "v-btn",
            {
              staticClass: "primary mx-2",
              attrs: { disabled: _vm.$store.getters["Ajax/loading"] },
              on: { click: _vm.downloadAttachments }
            },
            [
              _vm._v(
                _vm._s(_vm.$t("delegation.decision.downloadAllAttachments")) +
                  " "
              )
            ]
          ),
          _c(
            "v-btn",
            {
              staticClass: "primary mx-2",
              attrs: { to: "/delegation/readonly/" + _vm.delegationDecision.id }
            },
            [_vm._v(_vm._s(_vm.$t("delegation.viewReadonly")))]
          ),
          _c("h2", [
            _vm._v(_vm._s(_vm.$t("delegation.decision.acceptanceHistory")))
          ]),
          _c("div", [
            _vm._v(
              " " +
                _vm._s(_vm.$t("delegation.decision.created")) +
                " " +
                _vm._s(_vm.$t("global.at")) +
                " " +
                _vm._s(_vm.delegationDecision.created_at) +
                " " +
                _vm._s(_vm.$t("global.by")) +
                " " +
                _vm._s(_vm.delegationDecision.created_by_name) +
                " (" +
                _vm._s(_vm.delegationDecision.created_by_login) +
                "). "
            )
          ]),
          _vm._l(_vm.delegationDecision.history, function(historyItem) {
            return _c("span", [_vm._v(_vm._s(historyItem) + " "), _c("br")])
          }),
          _vm.delegationDecision.status === 2 &&
          _vm.delegationDecision.hasPermissionForSubstantialDecision
            ? _c(
                "div",
                [
                  _c("h2", [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t(
                            "delegation.decision.hasPermissionForSubstantialDecision"
                          )
                        ) +
                        " "
                    )
                  ]),
                  _c(
                    "v-row",
                    { staticClass: "text-center" },
                    [
                      _c("v-spacer"),
                      _c(
                        "v-col",
                        {
                          staticClass: "choose-box elevation-5  vertical-align",
                          attrs: { md: "4", cols: "12" }
                        },
                        [
                          _c("h3", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("delegation.decision.positive.title")
                              )
                            )
                          ]),
                          _c("v-icon", { attrs: { size: "75px" } }, [
                            _vm._v("fa-check")
                          ]),
                          _c("p", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  this.delegationDecision.accepted_by_id == null
                                    ? _vm.$t(
                                        "delegation.decision.positive.description.substantial"
                                      )
                                    : _vm.$t(
                                        "delegation.decision.positive.description.substantialAlready"
                                      )
                                ) +
                                " "
                            )
                          ]),
                          _c("br"),
                          _c("br"),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                disabled: _vm.$store.getters["Ajax/loading"],
                                bottom: ""
                              },
                              on: {
                                click: function($event) {
                                  return _vm.accept()
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "delegation.decision.positive.acceptButton"
                                  )
                                )
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c("v-spacer"),
                      _c(
                        "v-col",
                        {
                          staticClass: "choose-box elevation-5",
                          attrs: { md: "4", cols: "12" }
                        },
                        [
                          _c("h3", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("delegation.decision.negative.title")
                              )
                            )
                          ]),
                          _c("v-icon", { attrs: { size: "75px" } }, [
                            _vm._v("fa-ban")
                          ]),
                          _c("p", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "delegation.decision.negative.description.substantial"
                                  )
                                ) +
                                " "
                            )
                          ]),
                          _c("br"),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                disabled: _vm.$store.getters["Ajax/loading"],
                                bottom: ""
                              },
                              on: {
                                click: function($event) {
                                  return _vm.deny()
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "delegation.decision.negative.denyButton"
                                  )
                                )
                              )
                            ]
                          ),
                          _c("br"),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                disabled: _vm.$store.getters["Ajax/loading"],
                                bottom: ""
                              },
                              on: {
                                click: function($event) {
                                  return _vm.denyAndRevert()
                                }
                              }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "delegation.decision.negative.denyAndRevertButton"
                                    )
                                  ) +
                                  " "
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c("v-spacer")
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.delegationDecision.hasPermissionForFinancialDecision &&
          _vm.delegationDecision.status === 3
            ? _c(
                "div",
                [
                  _c("h2", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "delegation.decision.hasPermissionForFinancialDecision"
                        )
                      )
                    )
                  ]),
                  _c(
                    "v-row",
                    { staticClass: "text-center" },
                    [
                      _c("v-spacer"),
                      _c(
                        "v-col",
                        {
                          staticClass: "choose-box elevation-5  vertical-align",
                          class: {
                            "border-positive":
                              _vm.delegationDecision.settled_at != null
                          },
                          attrs: { md: "4", cols: "12" }
                        },
                        [
                          _c("h3", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("delegation.decision.positive.title")
                              )
                            )
                          ]),
                          _c("v-icon", { attrs: { size: "75px" } }, [
                            _vm._v("fa-check")
                          ]),
                          _c("p", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.delegationDecision.settled_at == null
                                    ? _vm.$t(
                                        "delegation.decision.positive.description.financial"
                                      )
                                    : _vm.$t(
                                        "delegation.decision.positive.description.financialAlready"
                                      )
                                ) +
                                " "
                            )
                          ]),
                          _c("br"),
                          _c("br"),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                disabled: _vm.$store.getters["Ajax/loading"],
                                bottom: ""
                              },
                              on: {
                                click: function($event) {
                                  return _vm.settle()
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "delegation.decision.positive.acceptButton"
                                  )
                                )
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c("v-spacer"),
                      _c(
                        "v-col",
                        {
                          staticClass: "choose-box elevation-5",
                          attrs: { md: "4", cols: "12" }
                        },
                        [
                          _c("h3", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("delegation.decision.negative.title")
                              )
                            )
                          ]),
                          _c("v-icon", { attrs: { size: "75px" } }, [
                            _vm._v("fa-ban")
                          ]),
                          _c("p", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "delegation.decision.negative.description.financial"
                                  )
                                ) +
                                " "
                            )
                          ]),
                          _c("br"),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                disabled: _vm.$store.getters["Ajax/loading"],
                                bottom: ""
                              },
                              on: {
                                click: function($event) {
                                  return _vm.deny()
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "delegation.decision.negative.denyButton"
                                  )
                                )
                              )
                            ]
                          ),
                          _c("br"),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                disabled: _vm.$store.getters["Ajax/loading"],
                                bottom: ""
                              },
                              on: {
                                click: function($event) {
                                  return _vm.denyAndRevert()
                                }
                              }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "delegation.decision.negative.denyAndRevertButton"
                                    )
                                  ) +
                                  " "
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c("v-spacer")
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }